import { Primitive } from '@radix-ui/react-primitive';
import { type ComponentPropsWithoutRef, forwardRef, memo } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const workspaceSidebarNavigationItem = tailwindVariants({
  base: 'flex items-center truncate rounded-8 bg-transparent text-left font-normal text-14 no-underline outline-none transition-colors hover:no-underline ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-blue-9 focus-visible:ring-inset',
  variants: {
    appearance: {
      default:
        'gap-2 px-2 ads:text-secondary text-gray-11 ads:hover:bg-hover-subtle hover:bg-gray-5 active:bg-gray-5 ads:active:bg-hover-subtle ads:data-[selected=true]:bg-subtle data-[selected=true]:bg-gray-5',
      subNav:
        'group/workspace-sidebar-navigation-item gap-1.5 px-2.5 py-1 ads:text-metadata text-gray-10 ads:hover:bg-hover-subtle hover:bg-gray-2 ads:data-[selected=true]:bg-subtle data-[selected=true]:bg-gray-3 data-[selected=true]:font-medium ads:data-[selected=true]:text-primary data-[selected=true]:text-gray-12',
    },
    size: {
      small: 'h-6',
      medium: 'h-8',
      large: 'h-10',
    },
  },
  defaultVariants: {
    appearance: 'default',
    size: 'medium',
  },
});

export type WorkspaceSidebarNavigationItemVariants = VariantProps<typeof workspaceSidebarNavigationItem>;

export type WorkspaceSidebarNavigationItemProps = ComponentPropsWithoutRef<typeof Primitive.button> &
  WorkspaceSidebarNavigationItemVariants;

export const WorkspaceSidebarNavigationItem = memo(
  forwardRef<HTMLButtonElement, WorkspaceSidebarNavigationItemProps>(
    ({ appearance, className, size, ...restOfProps }, ref) => {
      return (
        <Primitive.button
          className={workspaceSidebarNavigationItem({ appearance, className, size })}
          ref={ref}
          {...restOfProps}
        />
      );
    },
  ),
);

WorkspaceSidebarNavigationItem.displayName = 'WorkspaceSidebarNavigationItem';
